import Vue from 'vue'
import VueRouter from 'vue-router'
const _ = require('lodash')

Vue.use(VueRouter)

const routes = []
const require_module = require.context('./modules', true, /.js$/)
require_module.keys().forEach((file_name) => {
  routes.push(require_module(file_name).default)
})

const router = new VueRouter({
  routes: _.flatMap(routes),
  // mode: 'history', 
  // // 2. 可选：配置 base（如果项目部署在子路径下，如 /app/，则设 base: '/app/'；本地开发默认 '/' 即可）
  // base: '/', 
})

export default router
